import { FunctionComponent } from 'react'
import BoardPreview from './BoardPreview'
import Hand from './Hand'
import Modal, { ModalComponentProps } from './Modal'
import Scoring from './Scoring'

type ModalHelpProps = {
	openModal: (modalName: string) => void
} & ModalComponentProps

const ModalHelp: FunctionComponent<ModalHelpProps> = ({ openModal, ...props }) => (
	<Modal title="How To Play" name="help" {...props}>
		<div className="help-board help-board--1">
			<BoardPreview cols={5} letters="EAUTCHDGYIJULOUSYHUQHOUSE" />
			<div className="help-board__text">
				<p>
					There is <b>one</b> 5-letter word to find in this word search.
				</p>
				<p>It may be horizontal, vertical or diagonal. It may be in reverse.</p>
			</div>
			<Hand />
		</div>
		<div className="help-board help-board--2">
			<BoardPreview cols={5} letters="GHBJKEAUTCHDGYIJULOUSYHUQ" />
			<div className="help-board__text">
				<p>Once you have found that word, another word can be found.</p>
				<p>There are ten words to find.</p>
				<p>That&apos;s all there is to it!</p>
			</div>
			<Hand />
		</div>
		<Scoring />
		<p>
			By default, the clock is not shown, so that the game is more relaxing. However, you can
			change this in the <b onClick={() => openModal('settings')}>Settings</b>.
		</p>
	</Modal>
)

export default ModalHelp
